import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../configuration'

export const addIncidentConfig: AddIncidentConfig<BaseballIncidentId> = {
  scoreIncidents: [BaseballIncidentId.Run, BaseballIncidentId.HomeRun],
  stoppedIncidents: [BaseballIncidentId.Foul],
  missedIncidents: [BaseballIncidentId.Strike, BaseballIncidentId.SwingAndMiss],
  highlightedIncidents: [
    BaseballIncidentId.TriplePlay,
    BaseballIncidentId.WildPitch,
    BaseballIncidentId.StolenBase,
    BaseballIncidentId.CaughtStealing,
    BaseballIncidentId.HitByPitch,
    BaseballIncidentId.DoublePlay,
    BaseballIncidentId.Error,
  ],
}
